export type LiffSessionState = "ready" | "login";

/** LIFF SDK owns the persistent login session; the app only keeps the short-lived token in memory. */
export function resolveLiffSession(isLoggedIn: boolean, idToken: string | null): { state: LiffSessionState; idToken?: string } {
  if (!isLoggedIn) return { state: "login" };
  if (!idToken) throw new Error("ไม่พบ LINE ID Token");
  return { state: "ready", idToken };
}
